import React from 'react'
import PropTypes from 'prop-types'

import CategoryTags from '../sections/category-tags'

export default function CategoryTagsFilters ({ fullScreenFiltersPage }) {
  return (
    <div className='all-filters-content'>
      <CategoryTags fullScreenFiltersPage={fullScreenFiltersPage} />
    </div>
  )
}

CategoryTagsFilters.propTypes = {
  fullScreenFiltersPage: PropTypes.bool
}
